<div class="d-flex">
  <div class="json-editor-wrapper">
    <div class="p-inputgroup">
      <div class="form-control disabled-input query-preview-box">
        <ng-container *ngFor="let part of monacoHelper.getQueryStringParts(jsonString)">
          <span *ngIf="part.type === 'text'">{{ part.value }}</span>
          <p-chip *ngIf="part.type === 'chip'" [label]="part.value" styleClass="mr-1 qs-chip"></p-chip>
        </ng-container>
      </div>
      <p-button
        type="button"
        [ngClass]="{ contentActive: value && value?.length !== 0 }"
        pRipple
        icon="pi pi-pencil"
        styleClass="p-button-warn"
        class="icon-color icon-edit"
        title="Editor"
        (onClick)="toggleEditor($event)"
      />
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="showEditor"
  (onHide)="closeDialog($event)"
  [modal]="true"
  [draggable]="true"
  [resizable]="true"
  [baseZIndex]="2500"
  [style]="{ width: '80vw', height: '90vh' }"
  appendTo="body"
  (onShow)="onShow($event)"
  (onResizeEnd)="onResizeEnd($event)"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-between align-items-center w-100">
    <span class="mb-0 dialog-header">{{currenttablename}}'s {{ isQueryStringEditor ? 'Query String' : 'Query' }}</span>
    </div>
  </ng-template>
  <div class="editorContainer row" style="height: 100%; margin: 0;">
    <div class="col-md-12 h-100p" style="padding: 0;">
      <ngx-monaco-editor 
        *ngIf="showEditor"
        [options]="editorOptions"
        class="json-editor"
        [ngClass]="{ 'error-border': validationMessage }"
        (onInit)="onEditorInit($event)"
        [(ngModel)]="value"
        style="height: 100%"
        ></ngx-monaco-editor>
    </div>
  </div>
  <small *ngIf="validationMessage" class="input-error-text">
    <span>{{validationMessage}}</span>
  </small>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-between align-items-center w-100">
      <button 
        type="button" 
        class="btn btn-primary cancel-btn preview-btn" 
        (click)="previewQuery()"
        [disabled]="!value"
      >
        <span>{{ 'PREVIEW_QUERY' | translate }}</span>
      </button>
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary cancel-btn"
          [ngClass]="{ 'read-only-editor': disableField }"
          (click)="closeDialog()"
        >
          {{ 'CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary btn-sm" *ngIf="!disableField" (click)="saveJson()" [disabled]="(formData?.isQueryString && !value?.trim()) || !isFormDirty">
          {{ 'SAVE_AND_CLOSE' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  styleClass="preview-query-dialog"
  [(visible)]="showPreviewDialog"
  [modal]="true"
  [draggable]="true"
  [resizable]="true"
  [baseZIndex]="3000"
  [style]="{ width: '60vw', height: '60vh' }"
  appendTo="body"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-between align-items-center w-100">
      <span class="mb-0 dialog-header">{{currenttablename ? currenttablename + "'s Query (Preview)" : 'Query (Preview)'}}</span>
    </div>
  </ng-template>
  <div class="editorContainer row">
    <div class="col-md-12 h-100p">
      <ngx-monaco-editor
        *ngIf="showPreviewDialog"
        [options]="previewQueryEditorOptions"
        [disabled] = "true"
        class="json-editor"
        [ngModel]="formattedQuery"
        (onInit)="onPreviewEditorInit($event)"
        style="height: 100%;"
      ></ngx-monaco-editor>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-primary cancel-btn"
      (click)="closePreviewDialog()"
    >
      {{ 'CLOSE' | translate }}
    </button>
  </ng-template>
</p-dialog>
